import { render, staticRenderFns } from "./stardisplay.vue?vue&type=template&id=df041d5a&"
import script from "./stardisplay.vue?vue&type=script&lang=js&"
export * from "./stardisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df041d5a')) {
      api.createRecord('df041d5a', component.options)
    } else {
      api.reload('df041d5a', component.options)
    }
    module.hot.accept("./stardisplay.vue?vue&type=template&id=df041d5a&", function () {
      api.rerender('df041d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8FVD0SYIMdlqC/JS/comp/stardisplay.vue"
export default component.exports